import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the ArticleCard / ArticleTile block. The
 * Builder `ctaText` input still lets an author override the label per-entry; this
 * message supplies the localizable default when no override is set.
 */
const messages = defineMessages({
  readMore: {
    id: "learningCenter.articleCard.read_more",
    defaultMessage: "Read More",
  },
});

export default messages;
